import { docsClient } from '@/clients/docs-client.js';

const MAX_SIZE = 50;

class ImgCache {
    private urlCache = new Map<string, Promise<string>>();

    async loadImage(documentId: string, thumbEl: HTMLImageElement) {
        if (!this.urlCache.has(documentId)) {
            const promise = this._fetchObjectUrl(documentId)
                .catch(err => {
                    this.urlCache.delete(documentId);
                    throw err;
                });
            this.urlCache.set(documentId, promise);
            this._evictIfNeeded();
        } else {
            // Move to tail so LRU eviction keeps recently-accessed entries
            const promise = this.urlCache.get(documentId)!;
            this.urlCache.delete(documentId);
            this.urlCache.set(documentId, promise);
        }

        try {
            thumbEl.src = await this.urlCache.get(documentId)!;
        } catch (err) {
            console.error('DocsClient: failed to load image', documentId, err);
            thumbEl.src = '';
        }
    }

    private async _fetchObjectUrl(documentId: string) {
        const blob = await docsClient.downloadDocument(documentId);
        return URL.createObjectURL(blob);
    }

    private _evictIfNeeded() {
        if (this.urlCache.size > MAX_SIZE) {
            const oldest = this.urlCache.keys().next().value!;
            this.urlCache.get(oldest)!.then(url => URL.revokeObjectURL(url)).catch(() => {});
            this.urlCache.delete(oldest);
        }
    }

    revokeUrlCache(documentIds: string[] = []) {
        documentIds.forEach(id => {
            if (this.urlCache.has(id)) {
                this.urlCache.get(id)!.then(url => URL.revokeObjectURL(url)).catch(() => {});
                this.urlCache.delete(id);
            }
        });
    }
}

export const imgCache = new ImgCache();